import { Entity, AtomicBlockUtils } from 'draft-js'
import { createPlugin } from 'draft-extend'
import DropZone from 'react-dropzone'
import IconSVG from 'svg-inline-react'

import * as FileAPI from 'app/api/FileAPI'

import imageIconSrc from '!svg-inline?removeTags=true!./image.svg'

const ENTITY_TYPE = 'IMAGE'
const BLOCK_TYPE = 'atomic'

const ImageButton = ({ editorState, onChange }) => {
  const addLink = src => {
    const contentState = editorState.getCurrentContent()
    const contentStateWithEntity = contentState.createEntity(ENTITY_TYPE, 'IMMUTABLE', { src })
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey()
    const newEditorState = AtomicBlockUtils.insertAtomicBlock(
      editorState,
      entityKey,
      ' '
    )
    onChange(newEditorState)
  }
  const onDrop = files => FileAPI
    .upload(files[0])
    .then(res => addLink(res.url))
  return (
    <DropZone onDrop={onDrop} className="rich-editor-toolbar-button">
      <IconSVG src={imageIconSrc}/>
    </DropZone>
  )
}

export default createPlugin({
  htmlToBlock: (nodeName, node, lastList, inBlock) => {
    if (nodeName === 'figure' && node.firstChild.nodeName === 'IMG' || (nodeName === 'img' && inBlock !== BLOCK_TYPE)) {
      return BLOCK_TYPE
    }
  },
  htmlToEntity: (nodeName, node) => {
    if (nodeName === 'img') {
      return Entity.create(ENTITY_TYPE, 'IMMUTABLE', { src: node.getAttribute('src') })
    }
  },
  blockRendererFn: (block) => {
    if (block.getType() === 'atomic' && block.length > 0 && Entity.get(block.getEntityAt(0)).getType() === ENTITY_TYPE) {
      return {
        component: ({ block }) => {
          const { src } = Entity.get(block.getEntityAt(0)).getData()
          return <img src={src} />
        },
        editable: false
      }
    }
  },
  blockToHTML: {
    atomic: {
      start: '',
      end: ''
    }
  },
  entityToHTML: (entity) => {
    if (entity.type === ENTITY_TYPE) {
      return `<img style="max-width: 230px;" src="${entity.data.src}" />`
    }
  },
  buttons: ImageButton,
})



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Editor/plugins/image/index.js